import { connect } from 'react-redux'
import AddTeacher from './add-teacher'
import { getSchoolTeamId } from '../../../../../../stores/school-team/school-team.selectors'
import { addTeacher } from '../../../../../../stores/school-team/school-team.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'
import { getErrorInfo } from 'pobble-components/dist/utils'
import { toast } from 'pobble-components/dist/toast'

const mapStateToProps = (state, { me }) => {
  return {
    schoolId: getSchoolTeamId(state)
  }
}

const mapDispatchToProps = dispatch => ({
  onSubmit: (schoolId, email) => {
    return dispatch(addTeacher(schoolId, email))
      .then(e => {
        return toast.success('The teacher was successfully invited.')
      })
      .catch(e => {
        if (getErrorInfo(e).ref === 'e0008') {
          toast.warn("Can't invite this user. They are a teacher already.")
        } else if (getErrorInfo(e).ref === 'e0009') {
          toast.warn(
            "Can't invite this user. They are already a teacher in another school."
          )
        } else {
          errorHandler(e)
        }
      })
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddTeacher)
